import React from 'react'

import { withTranslation as translate } from 'react-i18next'

const Error = ({ messageKey, variable, value, t }) => {
  if (variable && value) {
    return <div className='errorText'>{t(messageKey, { [variable]: value, interpolation: { prefix: '%{', suffix: '}' } })}</div>
  }
  return <div className='errorText'>{t(messageKey)}</div>
}

export default translate()(Error)
